import { createAsyncThunk } from '@reduxjs/toolkit';
import { cardAPI } from '../utils/api/cardAPI';

export const deleteCard = createAsyncThunk<void, 'DELETE_CARD'>('DELETE_CARD', async (creditCardId: string) => {
  await cardAPI.deleteCard(creditCardId);
});
